<script lang="ts">
	import Comment from './Comment.svelte';
	import { browser } from '$app/environment';
	import beansproutLogoSmall from '$lib/assets/beansprout-logo-small.svg';
	import dayjs from 'dayjs';
	import { CheckCircle2, CircleUser } from 'lucide-svelte';
	import StrapiContent from './StrapiContent.svelte';
	import { markedParse } from './utils';

	interface Props {
		comment: BaseComment;
		replyTo?: BaseComment | null;
		type?: 'question' | 'comment' | 'discussion';
	}

	let { comment, replyTo = $bindable(null), type = 'comment' }: Props = $props();

	function reply() {
		replyTo = comment;
	}
</script>

<div class="flex gap-3">
	<div>
		{#if comment.isAdminComment}
			<img src={beansproutLogoSmall} alt="beansprout logo" class="w-6" />
		{:else}
			<CircleUser class="fill-gray-mid text-white-pure" />
		{/if}
	</div>
	<div>
		<div class="mb-5">
			<span class="index-bold inline-flex items-center">
				{#if comment.isAdminComment}
					Beansprout <CheckCircle2 class="fill-green-primary text-white-pure w-4" />
				{:else}
					{comment.author.name}
				{/if}
			</span>
			<span class="index-regular text-gray-mid">
				• {dayjs(comment.createdAt).format('DD MMM YYYY hh:mm A')}
			</span>
		</div>
		{#if browser}
			{#await markedParse(comment.content) then content}
				<StrapiContent {content} class="mb-4" />
			{/await}
		{/if}
		<div class="mb-4">
			<button onclick={reply} class="link-primary body-bold">
				{type === 'question' ? 'Share an answer' : 'Reply'}
			</button>
		</div>

		{#if comment.children.length}
			<div class="border-gray-mid border-l-1 pl-3">
				<ul class="grid gap-4">
					{#each comment.children as childComment}
						<li>
							<Comment comment={childComment} bind:replyTo />
						</li>
					{/each}
				</ul>
			</div>
		{/if}
	</div>
</div>
